import { sequence } from 'iguazu';
import { queryProcedureResult } from 'iguazu-rpc';
import { CARD_PRODUCT, queryProducts, queryProductsRegistry } from 'axp-product-ducks';
import { ELIGIBLE_MARKETS } from '../constants';
import { getMappedAccountsWithMarkets, getOrigin } from '../selectors';
import { makeEligibilityArgs } from '../utils';
const queryCredoEligibility = function () {
  let {
    store: {
      dispatch,
      getState
    } = {},
    ownProps = {}
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const isEligibleFalse = {
    isEligible: false
  };
  const {
    feature
  } = ownProps;
  try {
    const {
      credoEligibility
    } = sequence([{
      key: 'registryData',
      handler: () => dispatch(queryProductsRegistry())
    }, {
      key: 'productsData',
      handler: () => dispatch(queryProducts({
        types: [CARD_PRODUCT]
      }))
    }, {
      key: 'credoEligibility',
      handler: () => {
        const state = getState();
        const origin = getOrigin(state);
        const {
          markets,
          mappedAccounts
        } = getMappedAccountsWithMarkets(state);
        // eslint-disable-next-line no-restricted-syntax -- mutual exclusive rules
        for (const market of markets) {
          if (!ELIGIBLE_MARKETS[market.toLowerCase()]) {
            return {
              status: 'complete',
              data: isEligibleFalse,
              promise: Promise.resolve(isEligibleFalse)
            };
          }
        }
        const eligibilityResponse = dispatch(queryProcedureResult({
          procedureName: 'readFeatureEligibilityForAccountV1',
          args: makeEligibilityArgs({
            origin,
            mappedAccounts,
            feature
          })
        }));
        const {
          data,
          promise: eligibilityPromise,
          error,
          ...rest
        } = eligibilityResponse;
        return {
          data: error ? isEligibleFalse : data,
          promise: eligibilityPromise.then(res => res instanceof Error ? isEligibleFalse : res),
          error,
          ...rest
        };
      }
    }]);
    const {
      data,
      status,
      error,
      promise
    } = credoEligibility();
    return {
      data,
      status,
      error,
      promise: promise.then(_ref => {
        let {
          credoEligibility: credo
        } = _ref;
        return credo;
      })
    };
  } catch (err) {
    return {
      status: 'complete',
      data: isEligibleFalse,
      promise: Promise.resolve(isEligibleFalse)
    };
  }
};
export default queryCredoEligibility;